exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".purchase-order-summary .purchase-order-history-value{font-family:monospace;font-size:14px}.purchase-order-summary .purchase-order-history-label{font-size:14px}.purchase-order-summary .po-summary-label{font-size:14px;margin-bottom:5px}.purchase-order-summary .delivery-window,.purchase-order-summary .vendor-notes{padding-bottom:20px}", ""]);

// exports
